import { ReactNode } from "react";
import { showTime } from "../Data/Date";
import { notSet } from "../Data/Api";
import { RateProgram } from "./ApiTypes";

function formatCheckInConstraint( prog: RateProgram ): string | null {
    const { inAfter, inBefore } = prog;
    if( !notSet( inAfter ) && !notSet( inBefore ) ) {
        return `${showTime( inAfter! )} – ${showTime( inBefore! )}`;
    }
    if( !notSet( inBefore ) ) {
        return `Before ${showTime( inBefore! )}`;
    }
    if( !notSet( inAfter ) ) {
        return `After ${showTime( inAfter! )}`;
    }
    return null;
}

function formatCheckOutConstraint( prog: RateProgram ): string | null {
    const { outAfter, outBefore } = prog;
    if( !notSet( outAfter ) && !notSet( outBefore ) ) {
        return `${showTime( outAfter! )} – ${showTime( outBefore! )}`;
    }
    if( !notSet( outBefore ) ) {
        return `Before ${showTime( outBefore! )}`;
    }
    if( !notSet( outAfter ) ) {
        return `After ${showTime( outAfter! )}`;
    }
    return null;
}

function RateProgramTimeTable( { checkIn, checkOut }: { checkIn: string | null; checkOut: string | null } ) {
    return (
        <div className="d-flex justify-content-center">
            <table cellPadding={3}>
                <tbody>
                    {checkIn && (
                        <tr>
                            <td className="text-start">
                                Check-In
                            </td>
                            <td>
                                {checkIn}
                            </td>
                        </tr>
                    )}
                    {checkOut && (
                        <tr>
                            <td className="text-start">
                                Check-Out
                            </td>
                            <td>
                                {checkOut}
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}

export function rateProgramType( prog?: RateProgram ): string | ReactNode {
    if( !prog ) {
        return "";
    }
    const checkIn = formatCheckInConstraint( prog );
    const checkOut = formatCheckOutConstraint( prog );
    if( !checkIn && !checkOut ) {
        return "Any time";
    }
    return <RateProgramTimeTable checkIn={checkIn} checkOut={checkOut} />;
}
